import React from 'react';
import styles from './ProfileLoading.module.css';

interface ProfileLoadingProps {
  onBack?: () => void;
}

const ProfileLoading: React.FC<ProfileLoadingProps> = ({ onBack }) => {
  return (
    <div className={styles.wrapper}>
      <div 
        className={styles.backgroundImage} 
        style={{ 
          backgroundImage: 'linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%)'
        }} 
      />
      <div className={styles.container}>
        {onBack && (
          <button 
            className={styles.backButton}
            onClick={onBack}
          >
            ‹
          </button>
        )}
        <div className={styles.loadingContent}>
          <div className={styles.spinner} />
        </div>
      </div>
    </div>
  );
};

export default ProfileLoading; 